import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class MerchantMobile extends Component {
    state = {
        merchantMobileLists: [],
        merchantMobileValue: '',
        isMerchantMobileLoading: true
    };

    componentDidMount() {
        this.getMerchantMobileList();
    }

    resetMerchantMobileFilter() {
        this.setState({
            merchantMobileValue: [],
        });
    }

    getMerchantMobileList() {
        axios.get(config.get('API_URL') + '/filters/get-merchant-mobile/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_type: this.props.userType,
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((cf_merchant_contact_number, index) => {
                    mList.push({value: cf_merchant_contact_number.cf_merchant_contact_number, label: cf_merchant_contact_number.cf_merchant_contact_number})
                });
                this.setState({
                    merchantMobileLists:mList,
                    isMerchantMobileLoading: false
                })
            }

        });
    }

    changeMerchantMobile(optionSelected) {
        let value = '';
        let selectedMobiles = [];
        if (optionSelected.length < 1) {
            value = null;
            selectedMobiles = '';
        } else {
            optionSelected.forEach((item) => {
                selectedMobiles.push(item.value);
                const index = this.state.merchantMobileLists.findIndex(obj => obj.value === item.value);
                this.state.merchantMobileLists.move(index, 0).join(',');
            });
        }

        this.props.onSelectMerchantMobile(optionSelected, selectedMobiles);
        this.setState({
            merchantMobileValue: optionSelected,
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="merchant_mobile"
                isMulti
                value={this.state.merchantMobileValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeMerchantMobile.bind(this)}
                options={this.state.merchantMobileLists}
                placeholderButtonLabel="Select [Merchant Mobile]"
                isLoading={this.state.isMerchantMobileLoading}
            />
        );
    }
}

export default MerchantMobile;
